import { render, staticRenderFns } from "./CarouselNavNextBT.vue?vue&type=template&id=47b7cbe8&scoped=true"
import script from "./CarouselNavNextBT.vue?vue&type=script&lang=js"
export * from "./CarouselNavNextBT.vue?vue&type=script&lang=js"
import style0 from "./CarouselNavNextBT.vue?vue&type=style&index=0&id=47b7cbe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b7cbe8",
  null
  
)

export default component.exports